/*global $:false */

import SearchM from './recordm.model.search.js';

//Model responsible for executing advanced searches
var AdvancedSearchM = function(core, searchUrl, downloadAllUrl, downloadSelectedUrl) {
    this._core = core;

    /* eslint-disable-next-line prefer-rest-params */
    SearchM.apply(this, arguments);

    //when entities are selected for export we will use the (simple) base exportUrl
    // (its simpler to build the query)
    this.downloadSelectedUrl = downloadSelectedUrl + "?";
};

AdvancedSearchM.prototype = new SearchM();
AdvancedSearchM.prototype.constructor = AdvancedSearchM;
AdvancedSearchM.prototype._name = 'AdvancedSearchM';

// set raw to true to get the search parameters and not a ES query.
// The result when raw is true is a json string
AdvancedSearchM.prototype.getCurrentQuery = function(raw) {
    if (!raw) {
        return AdvancedSearchM._buildSearchQuery(this._query || []);
    } else {
        return JSON.stringify(this._query);
    }
};

AdvancedSearchM.prototype.getSearchParameters = function() {
    return this._query;
};

AdvancedSearchM.prototype.getExportURL = function(selectedIds, visibleColumnsNames, visibleColumnsLabels) {
    var query = this.getCurrentQuery(),
        exportHasSelectedIds = (selectedIds && selectedIds.length > 0),
        url = (exportHasSelectedIds ? this.downloadSelectedUrl : this.downloadUrl);

    url += 'vc=' + encodeURIComponent(visibleColumnsNames);
    url += '&vcn=' + encodeURIComponent(visibleColumnsLabels);

    if (this.isSorted()) {
        url += '&sort=' + encodeURIComponent(this.getSortField());
        url += '&ascending=' + this.isSortAscending().toString();
    }

    if (exportHasSelectedIds) {
        query = selectedIds.map(function(id) {
            //By default all records have the id column as the identifier.
            return "id:" + id;
        }).join(" OR ");

        return url + "&q=" + encodeURIComponent(query);

    } else {
        return url + "&aq=" + encodeURIComponent(query);
    }
};

// ## Private Helpers

/*
 * Private method that executes a search
 * opts:
 * *`refresh`: parameter indicates whether it's a refresh search action or not
 * *`onSearchDone`: the callback to invoke after the search is done
 * *`eventId`: (OPTIONAL) the search request identifier in order to be able to perform
 * multiple searches in different modules at the same time
 */
AdvancedSearchM.prototype._executeSearch = function(opts) {
    var _this = this,
        _opts = opts || {},
        from = _opts.refresh ? 0 : this._from,
        rowsToFetch = this._rowsPerPage,
        searchResults = [],
        eventId = opts && opts.eventId ? opts.eventId : "";

    if (_opts.refresh && this._searchResults.length > this._rowsPerPage) {
        rowsToFetch = this._searchResults.length;
    }

    $.ajax({
        url: this._buildSearchUrl(from, rowsToFetch, this._sortField, this._sortAsc),
        type: 'POST',
        contentType: 'application/json',
        data: AdvancedSearchM._buildSearchQuery(this._query),
        success: function(data) {

            if (_opts.refresh) {
                _this._clearSearchResults();
            }

            _this._totalMatchingInstances = data.hits.total.value;
            _this._storeResults(data);

            searchResults = _this._searchResults;

            if (typeof _opts.onSearchDone === 'function') {
                _opts.onSearchDone()
            }
        },
        error: function(req) {
            window.console.log("SEARCH:ERROR: " + req.status + " : " + req.statusText + ":" + req.responseText);
            _this._core.publish('recordm:search:error' + eventId, {errorCode: req.status});
        },
        complete: function() {
            _this._core.publish('recordm:search:finished' + eventId, {advancedSearch: true, searchResults: searchResults});
        }
    });
};

//Private helper that builds a search string
AdvancedSearchM.prototype._buildSearchUrl = function(from, rowsToFetch, sortField, sortAsc) {
    var endpointUrl = this.searchurl +
                      '?from=' + (from) +
                      '&size=' + (rowsToFetch);

    if (sortField) {
        endpointUrl += "&sort=" + sortField +
                       "&ascending=" + sortAsc;
    }

    return endpointUrl;
};

AdvancedSearchM._queryOperators = {
    EQUALS: "EQUALS",
    DATE_EQUALS: "DATE_EQUALS",
    EQUALS_PHRASE: "EQUALS_PHRASE",
    EXACT_MATCH: "EXACT_MATCH",
    STARTS_WITH: "STARTS_WITH",
    ENDS_WITH: "ENDS_WITH",
    CONTAINS: "CONTAINS",
    GREATER_THAN: "GREATER_THAN",
    LOWER_THAN: "LOWER_THAN"
};

AdvancedSearchM._negativeQueryOperators = (function(ops) {
    var ret = {};

    for (var key in ops) {
        if (Object.prototype.hasOwnProperty.call(ops, key)) {
            ret["NOT_" + key] = "NOT_" + ops[key];
        }
    }

    return ret;
})(AdvancedSearchM._queryOperators);

AdvancedSearchM.queryOperators = $.extend({},
    AdvancedSearchM._queryOperators,
    AdvancedSearchM._negativeQueryOperators
);

/*
* Given a JSON object with advanced search parameters (like those on the advanced search URL)
* it returns the corresponding JSON query
*/
AdvancedSearchM.buildSearchQuery = function(searchParameters) {
    return AdvancedSearchM._buildSearchQuery(searchParameters);
};

//private helpers for the building of a search request body
AdvancedSearchM._buildQueryValueForOperator = function(value, operator) {
    var queryValue = '',
        ops = AdvancedSearchM.queryOperators;

    switch (operator) {
        case ops.EQUALS:
        case ops.NOT_EQUALS:
        case ops.EXACT_MATCH:
        case ops.NOT_EXACT_MATCH:
            queryValue = value;
            break;
        case ops.STARTS_WITH:
        case ops.NOT_STARTS_WITH:
            queryValue = value + '*';
            break;
        case ops.ENDS_WITH:
        case ops.NOT_ENDS_WITH:
            queryValue = '*' + value;
            break;
        case ops.CONTAINS:
        case ops.NOT_CONTAINS:
            queryValue = '*' + value + '*';
            break;

        default:
            queryValue = value;
            window.console.log("SEARCH:ERROR: search operator not supported: " + operator);
            break;
    }

    return queryValue;
};

AdvancedSearchM._buildQueryStringPart = function(fieldName, value, operator) {
    return {
        query_string: {
            default_field: fieldName,
            query: AdvancedSearchM._buildQueryValueForOperator(value, operator),
            default_operator: "AND"
        }
    };
};
AdvancedSearchM._buildTasksQueryStringPart = function(fieldName, value, operator) {
    return {
        nested: {
           path: fieldName,
           query: {
              query_string: {
                  default_field: `${fieldName}.name`,
                  query: AdvancedSearchM._buildQueryValueForOperator(value, operator),
                  default_operator: "AND"
              }
           }
        }
    };
};


AdvancedSearchM._buildExactQueryPart = function(fieldName, value, operator) {
    return {
        query_string: {
            query: fieldName + ":\"" + AdvancedSearchM._buildQueryValueForOperator(value, operator) + "\"",
            default_operator: "AND"
        }
    };
};

AdvancedSearchM._buildMatchPhraseQueryPart = function(fieldName, value) {
    var phraseQuery = {};
    phraseQuery[fieldName] = value;

    return {match_phrase: phraseQuery};
};

//http://www.elasticsearch.org/guide/en/elasticsearch/reference/current/query-dsl-range-query.html
AdvancedSearchM._buildQueryRangePart = function(fieldName, from, to, includeLower, includeUpper) {
    var range = {};

    range[fieldName] = {};

    if (from !== undefined) {
        range[fieldName][includeLower ? 'gte' : 'gt'] = from;
    }

    if (to !== undefined) {
        range[fieldName][includeUpper ? 'lte' : 'lt'] = to;
    }

    return {range: range};
};

/*
* Given a JSON object with advanced search parameters (like those on the advanced search URL)
* it returns the corresponding JSON query
*/
AdvancedSearchM._buildSearchQuery = function(searchParameters) {
    var searchQuery = { "query": { "bool": {} } };

    searchQuery.query.bool.must_not = searchParameters.filter(function(parameter) {
        return parameter.operator.substring(0, 4) === 'NOT_';
    }).map(AdvancedSearchM._parseSearchParameter);

    searchQuery.query.bool.must = searchParameters.filter(function(parameter) {
        return parameter.operator.substring(0, 4) !== 'NOT_';
    }).map(AdvancedSearchM._parseSearchParameter);

    return JSON.stringify(searchQuery);
};

AdvancedSearchM._parseSearchParameter = function(parameter) {
    var ops = AdvancedSearchM.queryOperators,
        paramValue = parameter.value;

    //whenever the search value is empty treat it as a must existing field (i.e. a query like "field:*")
    if (paramValue === undefined || paramValue === null || paramValue === '') {
        if(parameter.type === 'TASKS'){
           return AdvancedSearchM._buildTasksQueryStringPart(parameter.field, '*', parameter.operator);
        }
        return  AdvancedSearchM._buildQueryStringPart(parameter.field, '*', ops.EQUALS);
    }

    // Avoid query errors when finding values based on $time. Escaping ':'
    parameter.value = parameter.value.replace(/:/g, '\:');


    //escape es query chars in field names when .raw is to be appended to the field name
    if(!parameter.escaped && (parameter.operator === ops.EXACT_MATCH || parameter.operator === ops.NOT_EXACT_MATCH)){
        //someday JBARATA: substituir estes replaces pelo uso do https://github.com/lanetix/node-elasticsearch-sanitize/blob/master/index.js
        parameter.field = parameter.field
            .replace(/[\*\+\-=~><\"\?^\${}\(\)\:\!\/[\]\\\s]/g, '\\$&') // replace single character special characters
            .replace(/\|\|/g, '\\||') // replace ||
            .replace(/\&\&/g, '\\&&') // replace &&
            .replace(/AND/g, '\\A\\N\\D') // replace AND
            .replace(/OR/g, '\\O\\R') // replace OR
            .replace(/NOT/g, '\\N\\O\\T'); // replace NOT

        parameter.escaped = true; //Set this to true so that it won't get escaped more than once
    }


    switch (parameter.operator) {
        case ops.GREATER_THAN:
        case ops.NOT_GREATER_THAN:
            return AdvancedSearchM._buildQueryRangePart(
                parameter.field,
                parameter.value,
                undefined,
                false,
                undefined
            );

        case ops.LOWER_THAN:
        case ops.NOT_LOWER_THAN:
            return AdvancedSearchM._buildQueryRangePart(
                parameter.field,
                undefined,
                parameter.value,
                undefined,
                false
            );

        case ops.EQUALS_PHRASE:
        case ops.NOT_EQUALS_PHRASE:
            // we do not want to support wildcards in phrase matches because it would be part of the phrase
            parameter.value = parameter.value.replace(/\*/g, '');
            return AdvancedSearchM._buildMatchPhraseQueryPart(parameter.field, parameter.value);

        case ops.EXACT_MATCH:
        case ops.NOT_EXACT_MATCH:
            return AdvancedSearchM._buildExactQueryPart(
                parameter.field + ".raw",
                parameter.value,
                parameter.operator
            );

        case ops.DATE_EQUALS:
        case ops.NOT_DATE_EQUALS:
            return AdvancedSearchM._buildQueryRangePart(
                parameter.field,
                parameter.value,
                parseInt(parameter.value, 10) + 86400000, // plus 1d
                true,
                false
            );

        default:
            if (paramValue.toLowerCase) {
                //dates or numbers have no lower case (can occur in a equals search)
                paramValue = parameter.value.toLowerCase();
            }
            if(parameter.type === 'TASKS'){
               return AdvancedSearchM._buildTasksQueryStringPart(parameter.field, paramValue, parameter.operator);
            }
            return AdvancedSearchM._buildQueryStringPart(parameter.field, paramValue, parameter.operator);
    }
};

export default AdvancedSearchM;
